const ProjData = [
  {
    id: 1,
    title: "Skill Script",
    subTitle: "MERN, Typescript, Redux Toolkit, Razorpay, Tailwind, Chart.js",
    image: "Images/Project/skill-script.png",
    category: "WebDev",
    description:
      "• Built a LMS from scratch using React, TypeScript, Node.js, and MongoDB with Razorpay payments, JWT authentication, and role-based access control.\
            • Implemented Redux Toolkit for state management, real-time analytics with Chart.js, and high-performance video streaming via Cloudinary CDN.",
    liveLink: "https://skillscript.vercel.app/",
    gitLink: "https://github.com/Raj-Gurjar/EdTech-Complete.git",
    top: true,
  },
  {
    id: 2,
    title: "Cinematch",
    subTitle: "Python, Flask, ML, NLP, Html, CSS, JS",
    image: "Images/Project/movieRec.webp",
    category: "ML",
    description:
      "• This Website recommends 7 similar movies to your search using the ML algorithm(NLP).\
        • Uses CountVectorizer algo. for better efficiency and Flask as Backend.\
        • Made an Animated UI with HTML, CSS, and JS.\
        ",
    liveLink: "https://huggingface.co/spaces/hpratapsingh/moviee",
    gitLink: "https://github.com/Raj-Gurjar/Movie-Recommender",
    top: true,
  },
  {
    id: 3,
    title: "Swarupanand Organic Farm",
    subTitle: "ReactJs, SCSS",
    image: "Images/Project/swarupanand.png",
    category: "WebDev",
    description:
      "• Created a beautiful and modern organic farm demonstration website using ReactJS and SCSS.\
            • Implemented responsive design with clean UI/UX, showcasing organic farming practices and products.\
            • Utilized SCSS for advanced styling and animations, ensuring a visually appealing and user-friendly experience.",
    liveLink: "https://swarupanand-organic-farm.netlify.app/",
    gitLink: "https://github.com/Raj-Gurjar/Swarupanand.git",
    top: true,
  },
  {
    id: 4,
    title: "Mini-Loan App",
    subTitle: "ReactJs, ExpressJs, MongoDB, TailwindCss",
    image: "Images/Project/mini-loan.webp",
    category: "WebDev",
    description:
      "• Created a MERN stack Mini-loan app with user authentication, loan management, and admin approval.\
            • Utilized TailwindCSS and SCSS for responsive design and clean UI, ensuring cross-device usability.\
            • Deployed on Vercel, showcasing backend development, API integration, and project organization skills.",

    liveLink: "https://mini-loan-webapp.vercel.app/",
    gitLink: "https://github.com/Raj-Gurjar/Mini-Loan-App",
    top: true,
  },
  {
    id: 5,
    title: "Chiclets-UI",
    subTitle: "ReactJs, TailwindCss, Scss, Routing",
    image: "Images/Project/chiclets-img.webp",
    category: "WebDev",
    description:
      "• Created a pixel-perfect Chiclets website using ReactJS, TailwindCSS, and SCSS.\
            • Achieved high fidelity to the original UI with a responsive design. \
            • Utilized TailwindCSS and SCSS for responsive design and clean UI, ensuring cross-device usability.",

    liveLink: "https://chiclets-ui.netlify.app/",
    gitLink: "https://github.com/Raj-Gurjar/Chiclets-UI-website.git",
    top: true,
  },
  {
    id: 6,
    title: "City Bank Website",
    subTitle: "ReactJs, Scss, Firebase",
    image: "Images/Project/bankingSys.webp",
    category: "WebDev",
    description:
      "• This is an interactive and fully responsive (mobile friendly) demo website for bank employees.\
         •  It can Add/Delete Customers, Money Transfer between two Customers, View Transaction History.\
         •  Neat ReactJs Folder Structures, Used Firebase as a Backend with clean Database entries.",
    liveLink: "https://citybank-employee.netlify.app/",
    gitLink: "https://github.com/Raj-Gurjar/banking-system-app",
    top: true,
  },
  {
    id: 7,
    title: "E-commerce Website",
    subTitle: " ReactJs, Nodejs, Express, MongoDB",
    image: "Images/Project/ecom-web.webp",
    category: "WebDev",
    description:
      "\
        • This is a website where customers can purchase goods.\
        • Social authentication is carried out using the Google API,\
        • Manual authentication is carried out with NodeJS,and data is saved on a MongoDB server.\
        • Used basic + advanced React concepts like Hooks, Redux etc.\
",
    liveLink: "https://dynamic-eclair-f42764.netlify.app/",
    gitLink: "https://github.com/Raj-Gurjar/E-Commerce-Website",
  },
];

export default ProjData;
